/**
 * @voltxampere/ui — Sparkfun Pro Micro variant (Sprint 47.5-2, placeholder)
 *
 * PLACEHOLDER. Sparkfun Pro Micro: ATmega32U4 + USB-HID + USB-mini-B.
 * Smaller footprint than Arduino UNO R3. Sprint 47.5 MVP renders as
 * mcu-execution with atmega328p family defaults (32U4 ISA shares AVR
 * subset with 328P); 32U4-specific USB-HID peripheral Sprint 51+.
 *
 * Reference: Sparkfun Pro Micro 5V/16MHz (ATmega32U4-AU, TQFP-44).
 * 12 digital I/O + 5 PWM + 4 analog. USB-HID native (no CDC bridge).
 *
 * Engine zero-diff invariant honored — canonical `mcu-execution`.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { opAmp } from "../op-amp.js";
export const mcuSparkfunProMicro = {
    id: "sparkfun-pro-micro",
    nameTr: "Sparkfun Pro Micro (ATmega32U4, USB-HID, placeholder)",
    nameEn: "Sparkfun Pro Micro (ATmega32U4, USB-HID, placeholder)",
    shortcut: "U",
    category: "active",
    viewBox: opAmp.viewBox,
    terminals: opAmp.terminals,
    defaultLabel: "U",
    defaultValue: "Pro Micro",
    schemaType: "mcu-execution",
    defaultParams: {
        family: "atmega328p",
        clockHz: 16e6,
        flashHex: "",
        instructionsPerTick: 1000,
        vSupply: 5,
    },
    renderSVG: () => opAmp.renderSVG(),
};
//# sourceMappingURL=mcu-sparkfun-pro-micro.js.map